"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCustomSettings = exports.getCustomSettings = void 0;

var _request = _interopRequireDefault(require("./request"));

var getCustomSettings = function getCustomSettings(resourceId, onGetAccessToken) {
  return (0, _request.default)("https://customizr.at.cimpress.io/v1/resources/".concat(resourceId, "/settings"), onGetAccessToken);
};

exports.getCustomSettings = getCustomSettings;

var setCustomSettings = function setCustomSettings(resourceId, customQuantities, onGetAccessToken) {
  return (0, _request.default)("https://customizr.at.cimpress.io/v1/resources/".concat(resourceId, "/settings"), onGetAccessToken, 'PUT', JSON.stringify(customQuantities));
};

exports.setCustomSettings = setCustomSettings;